const Theme = {
  logo_image_url: 'mtl.png',
  body_background_color: '#e61e30',

  button_color: '#e61e30',
  text_color: 'black',
  button_radius: 50,
}

export default Theme
